export default {
  ERROR_GETTING_ENTERPRISE_COMP_PLAN: "Error getting enterprise compensation plan",
};
